module.exports = __webpack_public_path__ + "img/vidlogo_iFund.1303c697.jpg";